export const companies = [
    "Openlane",
    "Yearin",
    "Goodsilron",
    "Condax",
    "Opentech",
    "Golddex",
    "Isdom",
    "Gogozoom",
    "Y-corporation",
    "Nam-zim",
    "Donquadtech",
    "Warephase",
    "Donware",
    "Faxquote",
    "Sunnamplex",
    "Lexiqvolax",
    "Sumace",
    "Treequote",
    "Iselectrics",
    "Zencorporation",
    "Plusstrip",
    "dambase",
    "Toughzap",
    "Codehow",
    "Zotware",
    "Statholdings",
    "Conecom",
    "Zathunicon",
    "Labdrill",
    "Ron-tech",
    "Green-Plus",
    "Groovestreet",
    "Zoomit",
    "Bioplex",
    "Zumgoity",
    "Scotfind",
    "Dalttechnology",
    "Kinnamplus",
    "Konex",
    "Stanredtax",
    "Cancity",
    "Finhigh",
    "Kan-code",
    "Blackzim",
    "Dontechi",
    "Xx-zobam",
    "Fasehatice",
    "Hatfan",
    "Streethex",
    "Inity",
    "Konmatfix",
    "Bioholding",
    "Hottechi",
    "Ganjaflex",
    "Betatech",
    "Domzoom",
    "Ontomedia",
    "Newex",
    "Betasoloin",
    "Mathtouch",
    "Rantouch",
    "Silis",
    "Plussunin",
    "Plexzap",
    "Finjob",
    "Xx-holding",
    "Scottech",
    "Funholding",
    "Sonron",
    "Singletechno",
    "Rangreen",
    "J-Texon",
    "Rundofase",
    "Doncon",
    "Acme Corporation",
    "Globex Corporation",
    "Soylent Corp",
    "Initech",
    "Bluth Company",
    "Umbrella Corporation",
    "Hooli",
    "Vehement Capital Partners",
    "Massive Dynamic",
    "Wonka Industries",
    "Stark Industries",
    "Gekko & Co",
    "Wayne Enterprises",
    "Bubba Gump",
    "Cyberdyne Systems",
    "Genco Pura Olive Oil Company",
    "The New York Inquirer",
    "Duff Beer",
    "Olivia Pope & Associates",
    "Sterling Cooper",
    "Ollivander's Wand Shop",
    "Cheers",
    "Krusty Krab",
    "Good Burger",
    "Airhead",
    "Motion Random",
    "Sporadic Systems",
    "FursKips",
    "Resource Random",
    "Muno Random",
    "Random Riders",
    "23Rd Century",
    "Destroy Random",
    "Vappa Shop",
    "Random Repair",
    "Fleet Random",
    "Knick Knacks",
    "Absent-Minded",
    "Random Reason",
    "Eclipse Random",
    "The Source",
    "Cowboy Random",
    "Million Random",
    "Ezoic",
    "Herb Random",
    "Nick’S Knacks",
    "Sense Random",
    "Random Refresh",
    "Lifestyle Random",
    "Shady Bootz",
    "Etc.",
    "Close Crowds",
    "MoonStore",
    "Limner Studio",
    "Life Paths",
]